import {
  Label,
  SizableText,
  SizeTokens,
  styled,
  ThemeableStack,
  ThemeableStackProps,
  YStack,
} from 'tamagui'
import { FormContainerBaseTypes } from './form-container-types'

type FormContainerProps = ThemeableStackProps &
  FormContainerBaseTypes & {
    id?: string
    size?: SizeTokens
    fullWidth?: boolean
    showHelperText?: boolean
  }

const StackContainer = styled(ThemeableStack, {
  variants: {
    fullWidth: {
      true: {
        width: '100%',
      },
    },
    labelInline: {
      true: {
        flexDirection: 'row',
        space: true,
        alignItems: 'center',
      },
    },
  } as const,
})

export function FormFieldContainer({
  label,
  children,
  helperText,
  id,
  size,
  labelProps,
  required,
  error,
  helperTextProps,
  showHelperText,
  hideLabel,
  isDirty,
  showRequired = true,
  showValidationIcon = true,
  ...rest
}: FormContainerProps) {
  return (
    <StackContainer space={!!rest.labelInline} {...rest}>
      {label && (
        <Label
          htmlFor={id}
          size={size || '$2'}
          alignItems="flex-start"
          height="auto"
          pb="$2"
          {...labelProps}
          color={error ? '$red10' : undefined}
          width={rest.labelInline ? 150 : undefined}
          justifyContent={rest.labelInline ? 'flex-end' : undefined}
          {...(hideLabel && {
            position: 'absolute',
            width: 1,
            height: 1,
            zIndex: -10000,
            overflow: 'hidden',
            opacity: 0.00000001,
            pointerEvents: 'none',
          })}
        >
          {label} {required && showRequired && ` *`}
        </Label>
      )}
      <YStack position="relative">{children}</YStack>
      {showHelperText && helperText && (
        <SizableText pt="$2" size="$1" color={error ? '$red10' : '$overlay10'} {...helperTextProps}>
          {helperText}
        </SizableText>
      )}
    </StackContainer>
  )
}
